import * as React from 'react';
import Attachment from '../../../attachment';

const ComponentImage = ({ item }) => {
  if (!item.parameters || !item.parameters.attachment) return null;

  if (item.parameters.attachment_id) {
    return (
      <Attachment
        className="Screen__Component__Image"
        item={item.parameters.attachment}
      />
    );
  }


  return (
    <Attachment
      className="Screen__Component__Image"
      item={item.parameters.attachment}
    />
  );
};

export default ComponentImage;
